export const Project = {
    projectName: "module",
    label: "Auto-Code",
    logo: "/assets/img/logo.png",
    menu: {
        items: [
            { label: "Tables", icon: "bi bi-server", htmlattribute: { to: "/table-list", "className": ({ isActive }) => `nav-link ${isActive ? "active" : ""}` } },
            { label: "Custom Requests", icon: "bi bi-arrow-left-right", htmlattribute: { to: "/request-list", "className": ({ isActive }) => `nav-link ${isActive ? "active" : ""}` } },
            {
                label: "Workflow",
                icon: "bi bi-diagram-3",
                id: "components-nav-workflow",
                htmlattribute: { to: "/workflows", "className": ({ isActive }) => `nav-link ${isActive ? "active" : ""}` } // unique ID
                
            },
            { label: "Custom Queries", icon: "bi bi-command", htmlattribute: { to: "/command-list", "className": ({ isActive }) => `nav-link ${isActive ? "active" : ""}` } },
            {
                label: "Users & Groups",
                icon: "bi bi-diagram-3",
                id: "components-nav-0",
                htmlattribute: {
                    to: "/user-group",
                    "className": "nav-link collapsed",
                    "data-bs-target": "#components-nav-0",
                    "data-bs-toggle": "collapse"
                },
                childs: [
                    { url: "/users", label: "Users", icon: "bi bi-people" },
                    { url: "/roles", label: "Roles", icon: "bi bi-circle" },
                    { url: "/permissions", label: "Permissions", icon: "bi bi-shield-check" },
                    { url: "/modules", label: "Modules", icon: "bi bi-shield-check" }
                ]
            },
            // {
            //   label: "CDP", 
            //   icon: "bi bi-diagram-3",
            //   id: "components-nav-1",
            //   htmlattribute: { 
            //     to: "/cdp/dashboard",
            //     "className": "nav-link collapsed",
            //     "data-bs-target": "#components-nav-1",
            //     "data-bs-toggle": "collapse" 
            //   },
            //   childs: [
            //     { url: "/cdp/dashboard", label: "Dashboard", icon: "bi bi-grid" },
            //     { url: "/cdp/profiles", label: "Profiles", icon: "bi bi-people" },
            //     { url: "/cdp/events", label: "Events", icon: "bi bi-activity" },
            //     { url: "/cdp/segments", label: "Segments", icon: "bi bi-diagram-2" },
            //     { url: "/cdp/campaigns", label: "Campaigns", icon: "bi bi-megaphone" },
            //     { url: "/cdp/rules", label: "Rules", icon: "bi bi-gear" },
            //     { url: "/cdp/scoring", label: "Scoring", icon: "bi bi-graph-up" },
            //     { url: "/cdp/goals", label: "Goals", icon: "bi bi-flag" },
            //     { url: "/cdp/context", label: "Context", icon: "bi bi-box" },
            //     { url: "/cdp/privacy", label: "Privacy", icon: "bi bi-shield-lock" },
            //     { url: "/cdp/settings", label: "Settings", icon: "bi bi-sliders" },
            //     { url: "/cdp/reports", label: "Reports", icon: "bi bi-file-earmark-text" },
            //     { url: "/cdp/monitor", label: "Monitor", icon: "bi bi-display" }
            //   ]
            // },
            { label: "Dashboards", icon: "bi bi-people", htmlattribute: { to: "/dashboard", "className": ({ isActive }) => `nav-link ${isActive ? "active" : ""}` } }
        ]
    }
};


